var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.icon)?_c(_setup.icon,{tag:"component",style:(_setup.iconStyles),attrs:{"size":_vm.size}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }